import { useCallback } from 'react';
import { observer } from 'mobx-react';
import partition from 'lodash/partition';
import classnames from 'classnames';

import style from './RepresentativesDropdown.module.scss';

import { RepresentativeStatus, RepresentativeType } from 'chaika-enums';

import { Icon, IconType } from '@components/Icon';
import { HoverDropdown } from '@components/HoverDropdown';
import { HoverDropdownItem } from '@components/HoverDropdown/HoverDropdown';

import { store } from '@store';

export const RepresentativesDropdown = observer(() => {
    const representatives = store.ehr.representativeList.values.filter(it => it.type === RepresentativeType.Child);
    const [confirmed, notConfirmed] = partition(representatives, it => it.status === RepresentativeStatus.Confirmed);

    const onOpenEhr = useCallback((id: string) => {
        window.open(`/patient/${id}?currentPage=profile`, '_blank');
    }, []);

    const buildItems = useCallback(
        (ids: string[]): HoverDropdownItem[] =>
            ids.map(id => ({
                key: id,
                content: (
                    <>
                        {store.patientStore.patientList.get(id)?.fullName}
                        <div className={style.iconRight}>
                            <Icon type={IconType.ARROW_LEFT} />
                        </div>
                    </>
                ),
                onClick: () => onOpenEhr(id),
            })),
        [onOpenEhr],
    );

    if (representatives.length === 0) {
        return null;
    }

    return (
        <div className={style.representatives}>
            {notConfirmed.length > 0 && (
                <HoverDropdown
                    items={buildItems(notConfirmed.map(it => it.representativeId))}
                    className={classnames([style.representativesItem, style.notConfirmed])}
                >
                    <Icon type={IconType.FAMILY} />
                    <div>{notConfirmed.length}</div>
                </HoverDropdown>
            )}
            {confirmed.length > 0 && (
                <HoverDropdown
                    items={buildItems(confirmed.map(it => it.representativeId))}
                    className={style.representativesItem}
                >
                    <Icon type={IconType.FAMILY} />
                    <div>{confirmed.length}</div>
                </HoverDropdown>
            )}
        </div>
    );
});
